@if (auth.isAuthenticated()) {
  <nav class="navbar navbar-expand-lg border-bottom bg-body-tertiary sticky-top">
    <div class="container">
      <a class="navbar-brand fw-bold text-primary d-flex align-items-center" routerLink="/">
        <img src="logo.svg" alt="" width="28" height="28" class="me-2 rounded" />PassKing
      </a>
      <div class="ms-auto d-flex align-items-center gap-2">
        <a
          class="btn btn-outline-secondary pk-nav-btn position-relative"
          routerLink="/social"
          title="Messages"
          aria-label="Messages"
        >
          <i class="bi bi-envelope"></i>
          @if (messages.totalUnread() > 0) {
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill text-bg-danger">
              {{ messages.totalUnread() }}
              <span class="visually-hidden">unread messages</span>
            </span>
          }
        </a>

        <div class="dropdown">
          <button
            type="button"
            class="btn btn-outline-secondary pk-nav-btn dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            title="Choose theme"
          >
            <i class="bi {{ theme.definition().icon }}" [style.color]="theme.definition().swatch"></i>
            <span class="d-none d-md-inline ms-1">{{ theme.definition().label }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li><h6 class="dropdown-header">Theme</h6></li>
            @for (t of theme.themes; track t.id) {
              <li>
                <button
                  type="button"
                  class="dropdown-item d-flex align-items-center gap-2"
                  (click)="theme.set(t.id)"
                >
                  <i class="bi {{ t.icon }}" [style.color]="t.swatch"></i>{{ t.label }}
                  @if (theme.theme() === t.id) {
                    <i class="bi bi-check-lg ms-auto text-primary"></i>
                  }
                </button>
              </li>
            }
          </ul>
        </div>

        <div class="dropdown">
          <button
            type="button"
            class="btn btn-outline-secondary pk-nav-btn dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            title="Account menu"
            aria-label="Account menu"
          >
            <i class="bi bi-person-circle"></i>
            <span class="d-none d-sm-inline ms-1 text-truncate">{{ auth.user()?.firstName }}</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <h6 class="dropdown-header">
                {{ auth.user()?.firstName }} {{ auth.user()?.lastName }}
                @if (auth.user()?.username) {
                  <div class="fw-normal text-body-secondary">&#64;{{ auth.user()?.username }}</div>
                }
              </h6>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/dashboard">
                <i class="bi bi-collection me-2"></i>Vault
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/social">
                <i class="bi bi-people me-2"></i>Friends
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/profile">
                <i class="bi bi-person me-2"></i>Profile
              </a>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <button type="button" class="dropdown-item text-danger" (click)="logout()">
                <i class="bi bi-box-arrow-right me-2"></i>Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
}

<main class="container py-4">
  <router-outlet />
</main>

<footer class="text-center text-body-secondary small py-3">
  <img src="logo.svg" alt="" width="32" height="32" class="rounded d-block mx-auto mb-2" />
  <div>&copy; {{ year }} Askenish Technology LTD</div>
  <button type="button" class="btn btn-link btn-sm link-secondary mt-1"
          (click)="showLegal.set(true)">
    Privacy Policy and Terms of Agreement
  </button>
</footer>

@if (showLegal()) {
  <app-legal-modal (close)="showLegal.set(false)" />
}
